import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DialogComponent } from '../dialog/dialog.component';
import { ConstantService } from "../providers/language.service";
import { Http, Response } from '@angular/http';
import { LanguageService } from '../providers/lang.service';
import { CookieService } from 'ngx-cookie-service';
import { CustomCookieService } from '../providers/mycookie.service';
import { DatePipe } from '@angular/common';
import { resource } from 'selenium-webdriver/http';
import { SharedServiceService } from '../shared/shared-service.service';

@Component({
  selector: 'footerbutton',
  templateUrl: './footer.component.html'
})

export class FooterComponent implements OnInit{

  accountFlag: boolean = true;
  shopFlag: boolean = false;
  orderFlag: boolean = false;
  invoiceFlag: boolean = false;
  account: string = ""
  shop: string = ""
  order: string = ""
  invoice: string
  whenClicked = [false, false];
  constructor(route: ActivatedRoute, private http: Http,
    private languageservice: ConstantService, private langService: LanguageService, private cookieService: CustomCookieService, private sharedService: SharedServiceService) {

  }

  ngOnInit() {
    this.langService.getJson().subscribe(data => {
      this.setLabels();
    });

    this.refreshScreen(this.sharedService.getFooterValue());

    this.sharedService.getFooterSelected().subscribe(data => {
      this.refreshScreen(data);
    });
  }

  refreshScreen(data){
    if (data === 'account') {
      this.changeFlags(true, false, false, false);      
    } else if (data === 'shop') {
      this.changeFlags(false, true, false, false);
    } else if (data === 'order') {
      this.changeFlags(false, false, true, false);
    } else if (data === 'invoice') {
      this.changeFlags(false, false, false, true);
    }
  }

  setLabels() {

    this.langService.getLangLabelValue("LblAccount").then(result => {
      this.account = result;
    });
    this.langService.getLangLabelValue("LblShop").then(result => {
      this.shop = result;
    });
    this.langService.getLangLabelValue("LblOrders").then(result => {
      this.order = result;
    });
    this.langService.getLangLabelValue("LblInvoice").then(result => {
      this.invoice = result;
    });
  }


  changeAccount() {   
    this.sharedService.changeProductsSearchStatus(false);
    this.sharedService.changeBackbuttonStatus(false);    
    this.changeFlags(true, false, false, false);
  }

  changeShop() {
    this.sharedService.changeProductsSearchStatus(true);
    this.sharedService.changeBackbuttonStatus(true);
    this.changeFlags(false, true, false, false);
  }

  changeOrder() {
    this.sharedService.changeProductsSearchStatus(false);
    this.sharedService.changeBackbuttonStatus(false);
    this.changeFlags(false, false, true, false);
  }

  changeInvoice() {
    //alert("Invoice page is under construction")
    this.sharedService.changeProductsSearchStatus(false);
    this.sharedService.changeBackbuttonStatus(false);    
    this.changeFlags(false, false, false, true);
  }

  changeFlags(account, shop, order, invoice) {

    this.accountFlag = account;
    this.shopFlag = shop;
    this.orderFlag = order;
    this.invoiceFlag = invoice;

  }
}



// WEBPACK FOOTER //
// ./src/app/footer/footer.component.ts